// Opsi kontrol ukur jarak. Nol state, nol this — makanya ditaruh di luar class.
export const POLYLINE_MEASURE_OPTIONS = {
  position: 'topleft',
  unit: 'kilometres',
  useSubunits: true,
  clearMeasurementsOnStop: false,
  showBearings: true,
  bearingTextIn: 'In',
  bearingTextOut: 'Out',
  tooltipTextFinish: 'Click to <b>finish line</b><br>',
  tooltipTextDelete: 'Press SHIFT-key and click to <b>delete point</b>',
  tooltipTextMove: 'Click and drag to <b>move point</b><br>',
  tooltipTextResume: '<br>Press CTRL-key and click to <b>resume line</b>',
  tooltipTextAdd: 'Press CTRL-key and click to <b>add point</b>',
  measureControlTitleOn: 'Turn on PolylineMeasure',
  measureControlTitleOff: 'Turn off PolylineMeasure',
  measureControlLabel: '&#8614;',
  measureControlClasses: [],
  showClearControl: true,
  clearControlTitle: 'Clear Measurements',
  clearControlLabel: '&times',
  clearControlClasses: [],
  showUnitControl: true,
  unitControlUnits: [
    'kilometres',
    'landmiles',
    'nauticalmiles',
  ],
  unitControlTitle: {
    text: 'Change Units',
    kilometres: 'kilometres',
    landmiles: 'land miles',
    nauticalmiles: 'nautical miles',
  },
  unitControlLabel: {
    metres: 'm',
    kilometres: 'km',
    feet: 'ft',
    landmiles: 'mi',
    nauticalmiles: 'nm',
  },
  unitControlClasses: [],
  tempLine: {
    color: '#00f',
    weight: 2,
  },
  fixedLine: {
    color: '#006',
    weight: 2,
  },
  arrow: {
    color: '#000',
  },
  startCircle: {
    color: '#000',
    weight: 1,
    fillColor: '#0f0',
    fillOpacity: 1,
    radius: 3,
  },
  intermedCircle: {
    color: '#000',
    weight: 1,
    fillColor: '#ff0',
    fillOpacity: 1,
    radius: 3,
  },
  currentCircle: {
    color: '#000',
    weight: 1,
    fillColor: '#f0f',
    fillOpacity: 1,
    radius: 6,
  },
  endCircle: {
    color: '#000',
    weight: 1,
    fillColor: '#f00',
    fillOpacity: 1,
    radius: 3,
  },
};

export default POLYLINE_MEASURE_OPTIONS;
